import React from 'react';
import { useTheme } from '../../../context/ThemeContext';

const CalendarComponent = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <div className={`calendar-wrapper ${isDarkMode ? 'bg-gray-800' : ''}`}>
      <iframe
        src={`https://cal.com/team/burnt/burnt-team-intro?overlayCalendar=false&theme=${isDarkMode ? 'dark' : 'light'}`}
        width="100%"
        height="600px"
        frameBorder="0"
        style={{ 
          borderRadius: '8px', 
          boxShadow: isDarkMode ? '0 2px 4px rgba(255, 255, 255, 0.1)' : '0 2px 4px rgba(0, 0, 0, 0.1)' 
        }}
        title="Talk with one of our co-founders"
        allow="camera; microphone; fullscreen; display-capture; autoplay"
      />
    </div>
  );
};

export default CalendarComponent;